import type { Schemas } from '@suvoda-uat/contracts';
import type { IncludeRecommendation } from './IncludeExcludeControl';

/**
 * The AI's include/exclude recommendation for a Test Case — the signal the
 * IncludeExcludeControl renders as an outline. The AI is the only thing that
 * recommends; the designer's Inclusion Decision (the fill) is authoritative.
 *
 * The AI Recommendation IS the engine's Selection Decision surfaced — there is
 * no separate recommendation object to read. `selected` → include, `excluded` →
 * exclude; `ambiguous` is the engine declining to take a position, so there is
 * no recommendation (no outline). This is a 1:1 relabelling of the engine's own
 * decision, not a derivation.
 */
export const toRecommendation = (
  testCase: Pick<Schemas['TestCase'], 'selectionDecision'>,
): IncludeRecommendation => {
  switch (testCase.selectionDecision.decision) {
    case 'selected':
      return 'include';
    case 'excluded':
      return 'exclude';
    default:
      return null;
  }
};
